export  default {

  //получить список уведомлений
  loadNotifyCounts(state, data){
    //присвоить количество уведомлений
      var ind = state.items.findIndex(x=>x.notifyCode==data.code);
      if(ind!=-1){
        state.items[ind].count=data.count;
      }
  },

  //добавить уведомление
  addNotify(state, code){
    var ind = state.items.findIndex(x=>x.notifyCode==code);
    if(ind!=-1){
      state.items[ind].count+=1;
    }
  },
  //обнулить уведомления
  clearNotifyCount(state, code){
    var ind = state.items.findIndex(x=>x.notifyCode==code);
    if(ind!=-1){
      state.items[ind].count=0;
    }
  }

}
